import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Product } from './models/product';
import { Observable, throwError } from 'rxjs';
import { retry, catchError, map } from 'rxjs/operators';

import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProductsService {

  // API path
  base_path = environment.API_URL;

  constructor(private http: HttpClient) { }

  // Http Options
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }

  // Handle API errors
  handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError(
      'Something bad happened; please try again later.');
  };


  // Create a new item
  createItem(item): Observable<Product> {
    // Convert rate to decimal *100
    //item.rate = item.rate*100;

    return this.http
      .post<Product>(this.base_path+'products', JSON.stringify(item), this.httpOptions)
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }

  // Get single product data by ID
  getItem(id): Observable<Product> {
    return this.http
      .get<Product>(this.base_path+'products/' + id)
      .pipe(
        map(response => new Product().deserialize(response))
       );

      // .pipe(
      //   retry(2),
      //   catchError(this.handleError)
      // )
  }

  // Get products data
  getList(): Observable<Product[]> {
    return this.http
      .get<Product[]>(this.base_path+'products')
      .pipe(
        map((response => response.map((product: Product) => new Product().deserialize(product))))
      );
      // .pipe(
      //   retry(2),
      //   catchError(this.handleError)
      // )
  }

  // Update item by id
  updateItem(id, item): Observable<Product> {
    return this.http
      .patch<Product>(this.base_path + 'products/' + id, JSON.stringify(item), this.httpOptions)
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }

  // Delete item by id
  deleteItem(id) {
    return this.http
      .delete<Product>(this.base_path + 'products/' + id, this.httpOptions)
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }
}
